import { gql } from '@apollo/client'

export const PRICES = gql`
  query MembershipProduct_Prices {
    course149: productCourse(slug: "shaders-for-the-web") {
      id
      lowestPrice {
        value
        currencyCode
      }
    }

    course499: productCourse(slug: "html-css-javascript-foundation") {
      id
      lowestPrice {
        value
        currencyCode
      }
    }
  }
`
